import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import i18n from 'I18n';

import { listImage } from 'components/banners/DisplayItems';
import BaseMultipleSelectorV2 from 'components/base/BaseMultipleSelectorV2';
import { ReactHookFormMarkDown } from 'components/base/CustomMarkDownArea';
import CustomTitleWithSwitch from 'components/base/CustomTitleWithSwitch';
import { errorMessage, hasError } from 'components/base/ErrorFieldMessage';
import { ReactHookFormImageUploader } from 'components/base/ImageUploader';
import InputFieldControl from 'components/base/InputFieldControl';
import BrandSelectDropdown from 'components/campaign/campaignCreation/BrandSelectDropdown';
import {
  CustomTitleWithDropDown,
  CustomTitleWithDropDownAndInput,
} from 'components/customer/CustomTitleWithDropDown';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import { EMAIL_REG, LanguageConfig } from 'config/CustomEnums';
import { MallErrorHandleFields } from 'containers/merchants/mall/MallErrorHandleFields';

import AdditionalInfoSection from './AdditionalInfoSection';
import EmailAddressInfoSection from './EmailAddressInfoSection';
import PhoneNumberInfoSection from './PhoneNumberInfoSection';

import './CreateMallStepOneContentSection.scss';

function CreateMallStepOneContentSection({
  mallName,
  districtList,
  language,
  languages,
  countryCodes,
  onFocus = () => {},
  setShowAlertPrompt = () => {},
  refreshDate,
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { watch, setValue, control, formState } = useFormContext();
  const { errors } = formState;

  useEffect(() => {
    dispatch({
      type: 'settings/getCountryCodeList',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const watchName = watch(`mallTranslations.${language}.name`);
  const watchIcon = watch('icon');
  const watchCoverPhoto = watch('coverPhoto');
  const watchDistrict = watch('district');
  const watchAddress = watch(`mallTranslations.${language}.address`);
  const watchPhoneNumberCountryCode = watch('phoneNumberCountryCode');
  const watchPhoneNumberSubscriberNumber = watch('phoneNumberSubscriberNumber');
  const watchEmailAddress = watch('emailAddress');
  const watchLatitude = watch('latitude');
  const watchLongitude = watch('longitude');
  const watchThirdPartyMallCode = watch('thirdPartyMallCode');
  const watchVisibleInFrontEnd = watch('visibleInFrontEnd');

  return (
    <div style={{ marginTop: '-30px' }} className="mall-create-step-one">
      <InputFieldControl
        name={`mallTranslations.${language}.name`}
        title={i18n.t('name', { locale: language })}
        rules={
          language === LanguageConfig.english
            ? { required: MallErrorHandleFields.name.required }
            : {}
        }
        value={watchName}
        setValue={(value) => {
          setValue(`mallTranslations.${language}.name`, value, {
            shouldDirty: true,
          });
        }}
        onFocus={() => {
          onFocus('name');
        }}
      />

      {/* <div style={{ display: 'grid' }}>
        <ReactHookFormImageUploader
          title={'Logo image (Optional)'}
          uploadSuggest={i18n.t('square_cover_photo_suggest')}
          name={'icon'}
          rules={{}}
          minWidth={600}
          minHeight={600}
          aspect={1}
          maxImageNum={1}
          value={watchIcon}
          language={language}
          uploadImageClicked={() => {
            onFocus('icon');
          }}
        />
      </div>

      <div style={{ display: 'grid' }}>
        <ReactHookFormImageUploader
          uploadSuggest={i18n.t('cover_photo_suggest')}
          name={'coverPhoto'}
          rules={{}}
          minWidth={900}
          minHeight={600}
          aspect={3 / 2}
          value={watchCoverPhoto}
          language={language}
          uploadImageClicked={() => {
            onFocus('coverPhoto');
          }}
        />
      </div>

      {language === LanguageConfig.english ? (
        <>
          <Controller
            control={control}
            name={'district'}
            render={() => (
              <>
                <CustomTitleWithDropDown
                  title="District(optional)"
                  source={districtList}
                  defaultValue={watchDistrict}
                  setValue={(value) => {
                    setValue('district', value, { shouldDirty: true });
                  }}
                  loadMoreAction={'storeModel/getDistrictList'}
                  filterAction={'storeModel/getDistrictList'}
                  onFocus={() => {
                    onFocus('district');
                  }}
                />
              </>
            )}
          />
        </>
      ) : null}
      <InputFieldControl
        name={`mallTranslations.${language}.address`}
        title={i18n.t('address', { locale: language })}
        rules={
          language === LanguageConfig.english
            ? { required: MallErrorHandleFields.address.required }
            : {}
        }
        value={watchAddress}
        setValue={(value) => {
          setValue(`mallTranslations.${language}.address`, value, {
            shouldDirty: true,
          });
        }}
        onFocus={() => {
          onFocus('address');
        }}
      />

      <PhoneNumberInfoSection language={language} languages={languages} />
      <EmailAddressInfoSection language={language} languages={languages} />
      <AdditionalInfoSection language={language} languages={languages} /> */}

      {language === LanguageConfig.english ? (
        <>
          {/* <InputFieldControl
            name={'latitude'}
            title={'Latitude'}
            style={{ width: 'auto' }}
            type="number"
            rules={
              language === LanguageConfig.english
                ? { required: MallErrorHandleFields.latitude.required }
                : {}
            }
            value={watchLatitude}
            setValue={(value) => {
              setValue('latitude', value, { shouldDirty: true });
            }}
          />

          <InputFieldControl
            name={'longitude'}
            title={'Longitude'}
            type="number"
            style={{ width: 'auto' }}
            rules={
              language === LanguageConfig.english
                ? { required: MallErrorHandleFields.longitude.required }
                : {}
            }
            value={watchLongitude}
            setValue={(value) => {
              setValue('longitude', value, { shouldDirty: true });
            }}
          /> */}

          <InputFieldControl
            name={'thirdPartyMallCode'}
            title={'Mall Code(optional)'}
            value={watchThirdPartyMallCode}
            setValue={(value) => {
              setValue('thirdPartyMallCode', value, { shouldDirty: true });
            }}
          />

          {/* <CustomTitleWithSwitch
            title={'Visible on front end'}
            tips={'Toggle off to hide from showing on front end'}
            defaultValue={
              watchVisibleInFrontEnd === undefined
                ? true
                : watchVisibleInFrontEnd
            }
            setValue={(isChecked) => {
              setValue('visibleInFrontEnd', isChecked, { shouldDirty: true });
            }}
            error={''}
          /> */}
        </>
      ) : null}
    </div>
  );
}

const mapPropsToState = (state) => ({
  checked: state.mall.checked,
  errorFields: state.mall.errorFields,
  saved: state.mall.saved,
  districtList: state.mall.districtList || [],
  formChanged: state.mall.formChanged,
  mallName: state.mall.detail?.mallName,
  countryCodes:
    state.settings.countryCodes?.map((item) => ({
      pk: item.value,
      name: item.value,
    })) || [],
});

export default connect(mapPropsToState)(CreateMallStepOneContentSection);
